import { Box, Stack, Typography, SxProps, Theme, SvgIcon } from '@mui/material';
import './style.scss';
// ----------------------------------------------------------------------

type Props = {
  onClick?: () => void;
  text?: string;
  sx?: SxProps<Theme>;
};

export default function FilterCursor({ onClick, text = 'Filter by', sx }: Props) {
  return (
    <Box bgcolor="background.paper" borderRadius={"16px"}>
      <Box
        onClick={onClick}
        className="filter-cursor"
      >
        <SvgIcon className="filter-cursor-icon" component={() => <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 12 12" fill="none">
          <path fill-rule="evenodd" clip-rule="evenodd" d="M0.546448 1.28956C0.628377 1.11298 0.805344 1 1.00001 1H11V1.5L11.3818 1.82286L7.50001 6.41307V10.5C7.50001 10.6733 7.41028 10.8342 7.26287 10.9253C7.11546 11.0164 6.93139 11.0247 6.7764 10.9472L4.7764 9.94721C4.60701 9.86252 4.50001 9.68939 4.50001 9.5V6.41307L0.618222 1.82286C0.492523 1.67422 0.464519 1.46614 0.546448 1.28956ZM9.92236 2H2.07766L5.38179 5.90714C5.45812 5.9974 5.50001 6.11179 5.50001 6.23V9.19098L6.50001 9.69098V6.23C6.50001 6.11179 6.54189 5.9974 6.61822 5.90714L9.92236 2Z" fill="#637381" />
        </svg>} />
        <Typography
          className="filter-cursor-text"
        >
          {text}
        </Typography>
      </Box>
    </Box>
  );
}
